import React, { Component, PropTypes } from 'react';

import { debounce } from 'lodash';

import { NitroHeading, NitroDrawer, NitroText } from 'nitro-components';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  renderFormNumberField,
  renderFormToggle,
  renderFormAutoSuggest
} from '../../../utils/forms/FormFieldValidatonWrapper';
import { Field, reduxForm } from 'redux-form';
// import * as actions from "../actions";
import * as actions from '../actions';

import CorporateQuoteWorkflowSetupApi from '../../../api/CorporateQuoteWorkflowSetupApi';

import styled from 'styled-components';

const FormRow = styled.div`
  margin-bottom: 16px;
`;

const renderSuggestion = suggestion => {
  return (
    <div className="suggestion-item">
      <span>
        <NitroText bold>
          {suggestion.FirstName}
          {' '}
          {suggestion.LastName}
          {' '}
        </NitroText>

      </span>

    </div>
  );
};

class ApproverDetail extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      suggestions: [],
      searchTermvalue: '',
      canSubmit: false
    };

    this.onSuggestionsFetchRequestedDebounced = debounce(this.onSuggestionsFetchRequestedDebounced, 500);
  }
  componentWillMount = () => {
    if (this.props.initialValues.User != null) {
      this.onSuggestionSelected(null, { suggestion: this.props.initialValues.User });
      const value = this.getSuggestionValue(this.props.initialValues.User);
      this.setState({
        searchTermvalue: value
      });
    }
  };

  submit = (values, eee) => {
    console.log('form submitted');
    if(values.Docusign==""){
      values.Docusign=false;
    }
    this.props.saveApproverDetail(values).then(data => {
      if (data.success) {
        this.props.close();
      }
    });
  };

  onSuggestionsFetchRequestedDebounced = value => {
    CorporateQuoteWorkflowSetupApi.getAssigneeList({
      lookup: value,
      CompanyCode: this.props.CompanyCode,
      CountryCode: this.props.CountryCode,
      workflowId: this.props.workflow.Id
    }).then(data => {
      this.setState({
        suggestions: data
      });
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.onSuggestionsFetchRequestedDebounced(value);
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  getSuggestionValue = suggestion => {
    return `${suggestion.FirstName} ${suggestion.LastName}`;
  };
  onSuggestionSelected = (event, obj) => {};

  onUserNameFieldChange = (event, { newValue, method }) => {
    this.setState({
      searchTermvalue: newValue
    });
  };

  saveApproverDetail = evt => {
    this.props.handleSubmit(this.submit)();
  };

  render() {
    const { pristine, submitting, valid } = this.props;

    const { searchTermvalue, canSubmit } = this.state;

    const inputProps = {
      placeholder: 'Approver',
      value: searchTermvalue,
      onChange: this.onUserNameFieldChange
    };
    return (
      <form onSubmit={this.props.handleSubmit(this.submit)}>
        <NitroDrawer
          isOpen={this.props.isOpen}
          close={this.props.close}
          padding="32px"
          width={400}
          staticFooter
          action={this.saveApproverDetail}
          actionDisabled={pristine || !valid}
          actionLabel="save">

          <NitroHeading label="APPROVER" size="1" variant="secondary" />

          <FormRow>

            <Field name="Level" component={renderFormNumberField} floatingLabelText="Level" fullWidth />
          </FormRow>

          <FormRow>
            <Field name="LevelOrder" component={renderFormNumberField} floatingLabelText="Order" fullWidth />

          </FormRow>
          <FormRow>
            <Field name="Docusign" component={renderFormToggle} label="Docusign" fullWidth />

          </FormRow>
          <FormRow>

            <Field
              name="User"
              label="Approver"
              component={renderFormAutoSuggest}
              suggestions={this.state.suggestions}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
              getSuggestionValue={this.getSuggestionValue}
              renderSuggestion={renderSuggestion}
              onSuggestionSelected={this.onSuggestionSelected}
              inputProps={inputProps}
            />

          </FormRow>

        </NitroDrawer>
      </form>
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  if (values.Level === '') {
    errors.Level = 'Required';
  } else if (values.Level < 0) {
    errors.Level = 'Cannot be less than 0';
  } else if (values.LevelOrder === '') {
    errors.LevelOrder = 'Required';
  } else if (values.LevelOrder < 0) {
    errors.LevelOrder = 'Cannot be less than 0';
  } else if (values.User == null || values.User.Id == null) {
    errors.User = 'Select an approver';
  }

  if (props.isFormValid) {
    props.isFormValid(values, errors);
  }

  return errors;
};

ApproverDetail.propTypes = {
  actions: PropTypes.object,
  detailsOpen: PropTypes.bool,
  closeDetails: PropTypes.func
};

const mapStateToProps = state => {
  return {};
  //   let {selectedApproverDetail} = state;

  //   selectedApproverDetail=selectedApproverDetail||{level:0,levelOrder:0,Docusign:false};

  //   return {initialValues:selectedApproverDetail };
};

const onChange = values => {
  console.log('form change');
  console.log(values);
  // console.log(this.state.SelectedUser);
  if (values.level < 0 || values.levelOrder < 0) {
    // this.canSave=false;
  } else {
    // this.canSave=true;
  }
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

let ApproverDetailForm = reduxForm({
  form: 'ApproverDetail', // a unique identifier for this form
  validate,
  onChange
})(ApproverDetail);

export default connect(mapStateToProps, mapDispatchToProps)(ApproverDetailForm);



// WEBPACK FOOTER //
// ./src/features/corporate-quote-workflow-setup/components/ApproverDetail.js